import React from 'react';
import Lottie from 'lottie-react';
import { animationData } from './final-checkmark';

type CheckmarkProps = { className?: string };

const Checkmark = ({ className = '' }: CheckmarkProps) => {
  return (
    <Lottie className={className} animationData={animationData} loop={false} />
  );
};

export { Checkmark };
